import { Box } from "theme-ui";

export default function ChevronRightIcon(props) {
  return (
    <Box
      as="svg"
      width="15"
      height="26"
      viewBox="0 0 15 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.292893 24.2929C-0.0976311 24.6834 -0.0976311 25.3166 0.292893 25.7071C0.683417 26.0976 1.31658 26.0976 1.70711 25.7071L0.292893 24.2929ZM13 13L13.7071 13.7071L14.4142 13L13.7071 12.2929L13 13ZM1.70711 0.292893C1.31658 -0.0976311 0.683418 -0.0976311 0.292894 0.292893C-0.0976304 0.683417 -0.0976304 1.31658 0.292894 1.70711L1.70711 0.292893ZM1.70711 25.7071L13.7071 13.7071L12.2929 12.2929L0.292893 24.2929L1.70711 25.7071ZM13.7071 12.2929L1.70711 0.292893L0.292894 1.70711L12.2929 13.7071L13.7071 12.2929Z"
        fill="white"
      />
    </Box>
  );
}
